//Added to save the warnings of ADA to the database
export interface WarningsInfoInterface {
  warning_message: string;
  warning_date: string;
  plant: string | null;
  user: string | null;
  account: string | null;
  platform: string;
  source: string;
}

//Added to save the warnings of ADA to the database
export class WarningsInfo {
  warning_message = '';
  warning_date = '';
  plant: string | null = null;
  user: string | null = null;
  account: string | null = null;
  platform = '';
  source = '';

  constructor(param: WarningsInfoInterface = {
    warning_message: '',
    warning_date: '',
    platform: '',
    source: '',
    plant: null,
    user: null,
    account: null,
  }) {
    this.warning_date = param.warning_date ?? '';
    this.warning_message = param.warning_message ?? '';
    this.plant = param.plant ?? null;
    this.user = param.user ?? null;
    this.account = param.account ?? null;
    this.source = param.source ?? '';
    this.platform = param.platform ?? '';
  }
}